import { createFileRoute } from '@tanstack/react-router';

import { getDashboardQueries, StatisticsPage } from '@dashboard';

export const Route = createFileRoute('/_app/os/dashboard')({
  loader: async ({ context }) => {
    const queries = getDashboardQueries();
    await context.queryClient.prefetchQuery(queries.organisations());
  },
  component: StatisticsPage,
  pendingComponent: StatisticsPage.Pending,
  errorComponent: StatisticsPage.Error,
});
